

// var QRCode = require('./qrcode.js');
var QRCode = require('qrcodejs2')
// var jweixin = require('./wxshare.js');
// import QRCode from './qrcode'
import jweixin from 'weixin-js-sdk'

//封装请求
const req = function (data, cb, url, md, header) {
	var rootDocments = 'https://apinew.koalaknow.com/api/ActivityRequest/InterfaceV1'; //正式域名
	// var rootDocments = 'https://apinewtest.koalaknow.com/api/ActivityRequest/InterfaceV1'; //测试域名
	if (url) {
		rootDocments = url;
	}
	var md = md || 'POST'
	var header = header || {
		'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
	}
	$.ajax({
		url: rootDocments,
		data: data,
		method: md,
		header: header,
		success: function(res) {
			return typeof cb == "function" && cb(res)
		},
		fail: function() {
			return typeof cb == "function" && cb(false)
		}
	})
}
const now = Date.now || function() {
	return new Date().getTime();
};
//将时间戳转换为时间
const timestampToTime = function (timestamp) {
	// var dis = timestamp;
	// console.log(dis)
	var date = new Date(parseInt(timestamp)); //时间戳为13位
	// console.log(date)
	var Y = date.getFullYear() + '年';
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
	var D = date.getDate() + '日';
	var h = date.getHours() + ':';
	var m = date.getMinutes() + ':';
	var s = date.getSeconds();
	return Y + M + D + h + m + s;
}

//获取地址栏信息
const getQueryString = function(name, chinese) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var reg_rewrite = new RegExp("(^|/)" + name + "/([^/]*)(/|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	var q = window.location.pathname.substr(1).match(reg_rewrite);
	if (chinese) {
		r = decodeURI(window.location.search).substr(1).match(reg);
		q = decodeURI(window.location.pathname).substr(1).match(reg_rewrite);
	}
	if (r != null) {
		return unescape(r[2]);
	} else if (q != null) {
		return unescape(q[2]);
	} else {
		return null;
	}
}

//获取设备信息
const SystemInfo = function() {
	var res = Array();
	res.screenWidth = window.screen.width;
	// console.log(res,'s')
	return res;
	var unit = res.screenWidth / 375;
}
//生成海报
const be_poster = function(code_url) {
	console.log(code_url)
	var unit = SystemInfo().screenWidth / 375;
	var size = setCanvasSize(); //动态设置画布大小
	createQrCode(code_url, "mycanvas", size.w, size.h);
}
//适配不同屏幕大小的canvas
const setCanvasSize = function() {
	var unit = SystemInfo().screenWidth / 375;
	var size = {};
	
		size.w = 150 * unit;
		size.h = 150 * unit;
	
	return size;
}
//调用插件中的draw方法，绘制二维码图片
var createQrCode = function (url, canvasId, cavW, cavH) {
	let qrcode = new QRCode('qrcode', {
	  width: 132,
	  height: 132,
	  text:url, // 二维码地址
	//   colorDark: "#000",
	//   colorLight: "#fff",
	})
	return qrcode
	// try {
	// 	let _img = QR.createQrCodeImg(url, {
	// 		size: parseInt(cavW)
	// 	})
	// 	localStorage.setItem('codeimg', _img)
	// 	// savehaibaoimg(_img);
	// 	// console.log(_img)
	// } catch (e) {
	// 	console.warn(e)
	// }
}

//微信h5分享
const wxshare = function(uid, shareurl, title, desc, img) {
	console.log(shareurl, 's')
	// jweixin.ready(function() {
	var test = window.location.href;
	// alert(test,'a')
	// console.log(test)
	$.ajax({
		url: 'https://www.koalaknow.com/DoVChar/GetVCharAbout',
		method: "POST",
		data: {
			'uid': uid,
			'currurl': test,
		},
		success: function(msg) {
			// console.log('http ok')
			var arr = new Array();
			arr = msg.split(',');
			var appId = arr[0],
				timestamp = arr[1],
				nonceStr = arr[2],
				signature = arr[3];
			jweixin.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: appId, // 必填，公众号的唯一标识
				timestamp: timestamp, // 必填，生成签名的时间戳
				nonceStr: nonceStr, // 必填，生成签名的随机串
				signature: signature, // 必填，签名，见附录1
				jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideAllNonBaseMenuItem', 'showMenuItems',
					'closeWindow',
				] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			});
			jweixin.ready(function() {
				// alert('ready');
				console.log('ready')
				jweixin.showMenuItems({
					menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3
				});
				//分享到朋友圈
				jweixin.onMenuShareTimeline({
					title: title, // 分享标题
					link: shareurl, // 分享链接
					imgUrl: img, // 分享图标
					success: function() {
						// 用户确认分享后执行的回调函数
					},
					cancel: function() {
						// 用户取消分享后执行的回调函数
					}
				});
				//分享给朋友
				jweixin.onMenuShareAppMessage({
					title: title, // 分享标题
					desc: desc, // 分享描述
					link: shareurl, // 分享链接
					imgUrl: img, // 分享图标
					type: '', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function() {
						console.log('分享给朋友')
						// 用户确认分享后执行的回调函数
					},
					cancel: function() {
						console.log('share fail')
						// 用户取消分享后执行的回调函数
					}
				});
				jweixin.error(function(res) {
					// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
				});
			});
		}
	})
	// });
}

/**
 * 判断是否是微信环境
 */
const getIsWxClient = function() {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true;
	}
	return false;
};
// 判断ios还是安卓

//获取国家区号列表
const get_codelist=function(cb) {
	var data = {
		cmd: "GetCountryList",
		orderType: "default",
	};
  req(data, function (res) {
    return typeof cb == "function" && cb(res)
  });
}

export default {
	req: req,
	now,
	getQueryString,
	be_poster,
	wxshare,
	getIsWxClient,
	SystemInfo,
	timestampToTime,
	createQrCode,
	get_codelist
}



//////////////////
// WEBPACK FOOTER
// ./service/http.js
// module id = aU28
// module chunks = 1